export default __webpack_public_path__ + "static/investment-image-10-fe6eea8093a8a5b159768f342507272e.jpg";